import * as React from 'react';
import { formatCityStateZip } from '../../modules/formatting';
import { formatWithOrdinalSuffix } from '../../utils/formatting';

export const AddressOneLine: React.FunctionComponent<models.JobAddressModel & { allowDev?: boolean } & { stopNumber?: number }> = ({ street, streetLineTwo, city, state, zip, stopNumber }) => {

    return <span className="address">
        {stopNumber && <b>{formatWithOrdinalSuffix(stopNumber) + ' Stop:'}</b>} {street} {streetLineTwo} {formatCityStateZip(city, state, zip)}
    </span>;
};